import {notificationPosition} from '@/constants/config';
import {i18n} from '@/setup/i18n-setup';

export const notificationType = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

export const newItemSuccess = (value) => {
  return {
    title: i18n.t('notification.add-item-success-title'),
    text: i18n.t('notification.add-item-success-message', {value}),
    color: 'success',
    position: notificationPosition,
    icon:'check_circle'
  }
};

export const updateItemSuccess = (value) => {
  return {
    title: i18n.t('notification.update-item-success-title'),
    text: i18n.t('notification.update-item-success-message', {value}),
    color: 'success',
    position: notificationPosition,
    icon:'check_circle'
  }
};

export const deleteItemSuccess = (value) => {
  return {
    title: i18n.t('notification.delete-item-success-title'),
    text: i18n.t('notification.delete-item-success-message', {value}),
    color: 'success',
    position: notificationPosition,
    icon:'check_circle'
  }
};

export const success = (title, message) => {
  return {
    title: i18n.t(title ? title : 'notification.general-info-title'),
    text: message,
    color: 'success',
    position: notificationPosition,
    icon: 'check_circle'
  }
};

export const info = (title, message) => {
  return {
    title: i18n.t(title ? title : 'notification.general-info-title'),
    text: message,
    color: 'primary',
    position: notificationPosition,
    icon:'info'
  }
};

export const warning = (title, message) => {
  return {
    title: i18n.t(title ? title : 'notification.general-warning-title'),
    text: message,
    color: 'warning',
    position: notificationPosition,
    icon:'warning'
  }
};

export const error = (title, message) => {
  return {
    title: i18n.t(title ? title : 'notification.general-error-title'),
    text: message,
    color: 'danger',
    position: notificationPosition,
    icon:'error'
  }
};

export const showStateNotification = (vs, data) => {
  if (data && data.title) {
    //clone state data to local data
    let localData = JSON.parse(JSON.stringify(data));

    vs.notify(localData);
  }

};

export const showLocalNotification = (vs, title, message, type) => {
  if (type === notificationType.SUCCESS) {
    vs.notify(success(title, message));
  } else if (type === notificationType.INFO) {
    vs.notify(info(title, message));
  } else if (type === notificationType.WARNING) {
    vs.notify(warning(title, message));
  } else if (type === notificationType.ERROR) {
    vs.notify(error(title, message));
  }
};

export const serverResponseStatusSet = (title, data) => {
  let { success, error, message } = data.status;

  return {
    title: i18n.t(title ? title : 'notification.general-error-title'),
    // text: value ? value.replace("GraphQL error: ", "") : i18n.t('unknown-error'),
    text: message ? message : i18n.t('unknown-error'),
    color: error ? 'danger' : success ? 'success' : 'primary',
    position: notificationPosition,
    // iconPack: 'feather',
    // icon:'icon-alert-circle',
  }
};
